import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ApiCredentialState {
  apiCredTypes: any;
  loaded: boolean;
  newUserInfo: any,
  loading: boolean,
  successUpdating: boolean;
  apiResponse: any;
  modalDataLoaded4: boolean;

}

const initialState: ApiCredentialState = {
  apiCredTypes: [],
  loaded: false,
  newUserInfo: [],
  loading: false,
  successUpdating: false,
  apiResponse: [],
  modalDataLoaded4: false

};
const apiCredentialSlice = createSlice({
  name: 'apiCredential',
  initialState,
  reducers: {
    fetchCredentialTypes(state, action: PayloadAction<{ seller_id: string, language: string }>) {
    },
    fetchCredentialTypesSuccess(state, action) {
      state.apiCredTypes = action.payload
    },
    fetchCredentialTypesFailure(state) {
    },
    fetchAllApiCredentialStart(state, action: PayloadAction<{ seller_id: string, language: string }>) {
      state.loaded = false;
      state.modalDataLoaded4 = false;
    },
    fetchAllApiCredentialSuccess(state, action: PayloadAction<any>) {
      state.loaded = true;
      const { language, usersData, useApiCredTypes } = action.payload;
      const credential_type_id = language === 'fr' ? 'credentials_type_fr' : 'credentials_type_en';
      state.newUserInfo = [...usersData];
      state.newUserInfo.map((user) => {
        if (user.hasOwnProperty('credentials')) {
          const env: string[] = [];
          user.credentials?.forEach((cred) => {
            const info = useApiCredTypes?.find((t) => {
              return t.credentials_type_id === cred.credential_type_id;
            });
            env.push(info[credential_type_id]);
          });
          const sortEnv = env.sort();
          user.env = sortEnv;
          return user;
        } else {
          user.env = [];
          return user;
        }
      });
      state.modalDataLoaded4 = true;
    },
    fetchAllApiCredentialFailure(state, action: PayloadAction<any>) {
      state.loaded = false;
      state.modalDataLoaded4 = false;
    },
    setApiCredTypes(state, action) {
      state.apiCredTypes = action.payload;
    },
    updateApiCredentialsStart(state, action: PayloadAction<{
      curr_user_id: string;
      formUpdates: string[];
      language: string;
      seller_id: string
    }>) {
      state.loading = true;
    },
    updateApiCredentialsSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.apiResponse = { ...action.payload }

    },
    updateApiCredentialsFailure(state, action) {
      state.loading = false;

    },
    setSuccessUpdating(state, action: PayloadAction<boolean>) {
      state.successUpdating = action.payload;
    }
  }
});

export const {

  fetchCredentialTypes,
  fetchCredentialTypesFailure,
  fetchCredentialTypesSuccess,
  fetchAllApiCredentialFailure,
  fetchAllApiCredentialStart,
  fetchAllApiCredentialSuccess,
  setApiCredTypes,
  updateApiCredentialsFailure,
  updateApiCredentialsStart,
  updateApiCredentialsSuccess,
  setSuccessUpdating
} = apiCredentialSlice.actions;
export default apiCredentialSlice.reducer;